import { Component } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router"

import { AlmacenesService } from '@app/_services/almacenes.service';

import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService, UsuariosService } from '../_services';

@Component({
  selector: 'app-almacenes',
  templateUrl: 'almacenes.component.html'
})

export class AlmacenesComponent {

  public seleccionados: number[] = [];
  private translate: TranslateService;
  public almacenes: [];
  user = this.userService.userValue;
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;
  closeResult = '';
  navigationSubscription;

  constructor(private almacenesService: AlmacenesService,
    translate: TranslateService,
    private menuService: MenuService, public router: Router,
    private translateService: TranslateService, private userService: UsuariosService,
    private modalService: NgbModal) {

      this.userService.user.subscribe(x => this.user = x);

    this.translate = translate;
    this.menuService.titulo = this.translate.instant('almacenes').toUpperCase();

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (this.router.url == '/almacenes') {
          this.menuService.titulo = this.translateService.instant('almacenes');
          this.almacenesService.GetAll().subscribe((result) => {
            this.almacenes = result.data;
          }
          );
        } else {
         
        }
      }
    });
  }

  ngOnInit() {
    this.almacenesService.GetAll().subscribe((result) => {
      this.almacenes = result.data;
      }
    );
  }

  onClickNuevo() {
    this.router.navigate(['almacenes/crear/']);
  }

  onClickEditar() {
    if (this.seleccionados[0] > 0) {
      this.router.navigate(['almacenes/editar/', this.seleccionados[0]]);
    }
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['almacenes/editar/', this.seleccionados[0]]);
    }
  }

  onClickEliminar(content) {
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  private eliminarRegistro(contentloading, contentNotErased) {
   
    this.almacenesService.delete({ ids: this.seleccionados }).subscribe(
      (data) => {
        if (data.error == false) {
          this.almacenesService.GetAll().subscribe((result) => {
            this.almacenes = result.data;
          }
          );
        }
        if (data.undeletedElements != "") {
          
          this.modalService.open(contentNotErased, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
        }
        this.modalReferenceloading.close();
      }
    );
    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, { backdrop: 'static', size: 'sm', keyboard: false, centered: true });
    this.seleccionados = [];
  }
}
